export default function PHP_getTraceAsString() {
  return (
    <div>
      <h1>PHP_getTraceAsString</h1>
    </div>
  );
}
